import gs from "gstyles";

import { IconName } from "gstyles/styleguide/icons/generated-icons";

export default function Icon({
  ...props
}: {
  name: IconName;
  size?: number;
  className?: string;
  [key: string]: unknown;
}) {
  return gs.icons({ ...props });
}
